export default "__VITE_ASSET__KOyXyrTR__";